<template>
  <div class="container-layout-default">
    <b-alert variant="info" :show="!!message_maintenance">
      <div class="container">
        <p class="mb-0 text-center">{{message_maintenance}}</p>
      </div>
    </b-alert>
    <div class="header user-header">
      <div class="mobile-header d-flex mr-auto">
        <div class="logo-container">
          <router-link to="/dashboard" class="logo-mobile">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 239.3 67.89"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M70.94 12.16l-5.55-5.54a6.29 6.29 0 00-.47-.43c-.24-.27-.48-.53-.73-.77C60.65 1.87 55.76 0 50.05 0c-7.54 0-15.93 3.31-23.3 9.05a5.08 5.08 0 00-10 .14l-.88 5.3a7.66 7.66 0 01-6.31 6.32l-5.3.87a5.09 5.09 0 000 10l5.3.87.28.07c-2.71 9-1.54 17.51 4 23.08l.48.45c.1.12.2.24.31.35l6 6c3.53 3.53 8.4 5.4 14.1 5.4a30.71 30.71 0 008.13-1.17 41.93 41.93 0 0011.26-5.1A52.56 52.56 0 0063 54.52a51.59 51.59 0 007.1-8.86 42.21 42.21 0 005.1-11.26c2.45-8.96.91-17.07-4.26-22.24zM4.87 28a1.35 1.35 0 010-2.66l5.29-.87a11.26 11.26 0 004.11-1.57 11.29 11.29 0 005.05-6.85 10 10 0 00.25-1l.87-5.3a1.34 1.34 0 012.65 0l.34 2.07.25 1.49.32 1.79c0 .16.08.31.12.47a10.76 10.76 0 00.64 2A11.31 11.31 0 0029 22.76a11.27 11.27 0 003.84 1.61c.18 0 .36.1.55.13l5.29.87a1.35 1.35 0 010 2.66l-1.87.3-3.42.57A11.55 11.55 0 0024 38.3l-.82 4.7-.07.47v.1a1.33 1.33 0 01-2.59.18 1 1 0 01-.06-.18l-.87-5.3a11.39 11.39 0 00-4-6.89 10.13 10.13 0 00-1.52-1.07 11.09 11.09 0 00-1.77-.85 10.16 10.16 0 00-1.19-.36c-.31-.08-.62-.18-.94-.23zm58.76-1.7a37.39 37.39 0 01-4.5 9.92 47.31 47.31 0 01-6.44 8 46.75 46.75 0 01-8 6.43 37.43 37.43 0 01-9.92 4.51 25.85 25.85 0 01-6.77 1 16.65 16.65 0 01-6.57-1.25A13 13 0 0118 52.79c-.21-.19-.43-.37-.63-.58-3.94-3.93-4.82-10.11-3.1-16.82a7.63 7.63 0 011.57 3.52l.88 5.3a5 5 0 002.65 3.66 5 5 0 006.51-1.57 4.72 4.72 0 00.49-.88c3 1.1 7.15.46 11.39-1.66a32.68 32.68 0 008.33-6.09 32.68 32.68 0 006.09-8.33c2.79-5.59 3-11 .1-13.93a7.44 7.44 0 00-4.42-2 12.38 12.38 0 00-1.51-.09c-4.36 0-9.79 2.46-14.67 6.75a7.63 7.63 0 01-4-5.33C34.92 8.42 43.15 5 50.05 5a14.64 14.64 0 0110.62 3.94c.3.31.58.62.84.94A12.7 12.7 0 0163.37 13c1.63 3.73 1.63 8.4.26 13.33zM25 59.69a22.8 22.8 0 003 .22 30.39 30.39 0 009.76-1.74l3.75 3.74C35.06 63.7 29.06 63.07 25 59.69zm26.44-2.28l-4-4a51.16 51.16 0 007.94-6.49l4.1 4.1a47.23 47.23 0 01-8.04 6.39zM65.86 43l-4-4a43.18 43.18 0 004.77-9.64l3.78 3.78A37 37 0 0165.86 43zM110.28 36.6l.65 6.91c-.61 1-4 3.05-8.85 3.05-8.92 0-10.69-6-10.69-10.49v-3.62a1.08 1.08 0 00-1.08-1.08h-1.53l-.28-7a5 5 0 003.34-4.42v-.89l8.56-2.09c0 .28 0 3-.12 6 8.64.12 10.61.93 10.61.93l-.29 7.1-10.36-.08v5.26c0 2.05 1.32 2.53 3.33 2.53a11.49 11.49 0 006.71-2.11zM144.29 22.29a8.51 8.51 0 00-7 3.28 1.45 1.45 0 01-2.59-.79c-.11-1.49-.22-2.14-.22-2.49L126 23.9c0 .48.16 4.78.16 10.48 0 5.29-.06 11.28-.1 15.28a4.49 4.49 0 004.49 4.54h.14a4.5 4.5 0 004.49-4.55c0-1.78 0-3.95-.07-6.27a.73.73 0 011.3-.47 9.46 9.46 0 007.32 3.65c7.39 0 10.36-5.83 10.36-11.89-.04-6.27-2.33-12.38-9.8-12.38zm-4.35 16.81h-4.71v-4.72a4.71 4.71 0 114.71 4.72z"/><circle class="cls-1" cx="118.32" cy="18.43" r="4.74"/><path class="cls-1" d="M122.91 24.88a7.89 7.89 0 01-9.17 0c0 .65.2 3.12.2 8.78 0 3.42 0 6-.07 7.93a4.5 4.5 0 109 0c0-1.92-.07-4.51-.07-7.93-.01-5.66.1-8.13.11-8.78z"/><circle class="cls-1" cx="234.56" cy="18.43" r="4.74"/><path class="cls-1" d="M239.14 24.88a7.87 7.87 0 01-9.16 0c0 .65.2 3.12.2 8.78 0 3.42 0 6-.07 7.93a4.49 4.49 0 109 0c0-1.92-.07-4.51-.07-7.93-.04-5.66.1-8.13.1-8.78z"/><circle class="cls-1" cx="192.85" cy="41.82" r="4.74"/><path class="cls-1" d="M184.84 34.46c0-8.68.12-11.61.12-12.17l-8.64 1.2a1.45 1.45 0 01-2.47 1 9.57 9.57 0 00-6.65-2.2c-6.55 0-10.17 4.5-10.17 11.89 0 7.08 3.62 12.38 10.17 12.38a8.56 8.56 0 007.55-4.26.73.73 0 011.35.34c.14 2.55.3 3.46.3 3.92L185 45c0-.53-.16-4.83-.16-10.54zm-9.11-.08a4.71 4.71 0 11-4.73-4.71h4.71zM226.69 34.46c0-8.68.12-11.61.12-12.17l-8.64 1.2a1.45 1.45 0 01-2.47 1 9.59 9.59 0 00-6.65-2.2c-6.56 0-10.17 4.5-10.17 11.89 0 7.08 3.61 12.38 10.17 12.38a8.53 8.53 0 007.54-4.26.74.74 0 011.36.34c.13 2.55.3 3.46.3 3.92l8.6-1.61c0-.48-.16-4.78-.16-10.49zm-9.11-.08a4.72 4.72 0 11-4.72-4.71h4.72z"/></g></g></svg>
          </router-link>
        </div>
      </div>
      <div class="header-content" v-if="isLoggedIn">
        <div class="user-balance">
          <icon-wallet class="icon-wallet" />
          <div class="balance-container">
            <router-link to="/dashboard/book" class="balance-current">
              {{ currentUser.balance }}
            </router-link>
            <div @click.stop.prevent="updateCurrentUser">
              <icon-arrow-clockwise />
            </div>
          </div>
        </div>

        <b-dropdown
          id="dropdown"
          toggle-class="d-flex align-items-center btn-outline-secondary"
          variant="primary"
          >
          <template #button-content>
            <div class="user-avatar-micro">
              <b-avatar size="24px" v-if="currentUser.avatar_url" :src="currentUser.avatar_url" />
              <b-avatar size="24px" v-else src="/avatar-default.jpeg" />
              <div v-if="currentUser.premium" class="premium-crown">👑</div>
            </div>
            <span class="d-none d-md-block">{{ currentUser.nickname || currentUser.username }}</span>
          </template>

          <b-dropdown-item  to="/settings/account">Minha conta</b-dropdown-item>
          <b-dropdown-item to="/settings/preferences">Preferências</b-dropdown-item>
          <b-dropdown-item @click.stop.prevent="logout">Sair</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="content-slots">
      <transition name="fade" mode="out-in">
        <slot />
      </transition>
    </div>
    <!-- </div> -->

    <site-footer></site-footer>

    <support-widget></support-widget>
  </div>
</template>

<script>
import UserService from '@/services/user.service'
// import HeaderSmall from '@/components/HeaderSmall'
import SiteFooter from '@/components/SiteFooter/index.vue'
import SupportWidget from '@/components/SupportWidget/index.vue'

export default {
  name: 'DefaultLayout',
  metaInfo: {
    bodyAttrs: {
      class: ['default-layout']
    }
  },
  components: {
    // HeaderSmall,
    SiteFooter,
    SupportWidget
  },
  computed: {
    currentUser () {
      return this.$store.getters['user/currentUser']
    },
    isLoggedIn () {
      return this.$store.getters['user/loggedIn']
    }
  },
  watch: {
    isLoggedIn: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          try {
            this.$cable.connection.connect(this.$store.getters['user/cableConnectionUrl'])
            // console.log('Conectado')
          } catch (_) {
            // console.log('Erro ao conectar ao webservice', _)
          }
        } else if (!newVal && oldVal) {
          try {
            this.$cable.connection.disconnect()
            // console.log('Desconectado')
          } catch (_) {
            // console.log('Erro ao desconectar', _)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    async logout () {
      await UserService.logout()
      this.$store.commit('user/logout')
    },
    async updateCurrentUser () {
      await this.$store.commit('user/updateCurrentUser')
    }
  }
}
</script>

<style lang="scss">
.container-layout-default {
  $sidebar-width: 240px;

  .base-row {
    flex-wrap: nowrap;
  }

  .content-slots {
    margin-top: 60px;
  }

  // .header {
    .header {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      background: var(--bg-color);
      height: 60px;
      z-index: 5;
      color: var(--text-color);
      display: flex;
      justify-content: flex-end;
      align-items: center;

      padding: 1rem;

      .mobile-header {
        // background: rgba(255, 255, 255, .4);
        // padding: 1rem;
        &.compact {
          display: flex !important;
        }
        .btn-sidebar {
          background: transparent;
          border: 0;
          color: black;
          padding: 0;
          width: 34px;
          height: 34px;
          margin: 0 1rem;

          &:focus,
          &:active {
            outline: 0;
            box-shadow: 0;
          }

          svg {
            width: 100%;
            height: 100%;
          }
        }

        .logo-container {
          display: flex;
          justify-content: center;
          align-items: center;

          .logo-mobile {
            width: 80px;
            height: auto;
            display: block;
            opacity: .7;
          }
        }
      }

      #dropdown{
        .dropdown-menu {
          background: var(--bg-color);

          a {
            color: var(--text-color)
          }
        }

        button {
          display: flex;
          align-items: center;
          background: transparent;
          border: none;

          color: var(--text-color)
        }
      }

      .header-content {
        display: flex;
        svg {
          fill: var(--text-color);
        }

        // padding: 1rem;

        .user-balance {
          display: flex;
          align-items: center;
          padding: .6rem;

          .icon-wallet {
            margin-right: 0.4rem;
          }

          div.balance-container {
            margin-bottom: 0px;
            cursor: pointer;
            overflow: hidden;
            filter: blur(3px);
            transition: filter 0.3s;

            display: flex;
            align-items: center;

            &:hover {
              filter: blur(0px);
              text-decoration: underline;
              cursor: pointer;
            }

            .balance-current {
              background-color: var(--text-color);
              color: var(--bg-color);
              font-family: var(--font-family-monospace);
              font-weight: bold;
              font-size: 0.8rem;
              display: block;
              padding: 0.2rem 0.5rem 0.1rem;
              border-radius: 19px;
              &:hover {
                text-decoration: none !important;
              }
            }

            svg {
              margin-left: 5px;
            }

            svg:hover {
              cursor: pointer;
            }
          }
        }

        .user-button, .dropdown-toggle {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.6rem;

          @media screen and (max-width: 512px) {
            display: none;
          }

          span:not(.b-avatar) {
            display: block;
            width: auto;
            max-width: 200px;
            text-overflow: ellipsis;
            word-break: break-all;
            overflow: hidden;
            height: 22px;
          }

          .b-avatar {
            margin-right: 0.4rem;
          }
        }
      }
    }
  // }
}
</style>
